<app-header></app-header>
<div class="hero-section section pt-0">
    <div class="container pt-5">
 
    </div>
   
  </div>

  <div class="about-section section container">
    <div class="row">
      <div class="col-12 col-lg-12 mb-3 mb-lg-0">
        <p class="display-5 fw-normal">SR Classic Coach</p>
        <p >
          SR Classic coach Company Limited is the transportation company which found in 2001, henceforth provides services for Passengers, Parcels and Luggage in more than six countries and more than 14 major cities starts from South Sudan, Uganda 🇺🇬, Kenya, Tanzania 🇹🇿, Burundi 🇧🇮, Zambia 🇿🇲, Zimbabwe 🇿🇼 and Democratic Republic of Congo 🇨🇩.
        </p>
       
      </div>
      
    </div>
  </div>
  <app-footer></app-footer>
  